export default __webpack_public_path__ + "static/media/photo--lg--wheel-1.062ff567.jpg";